import Modal from 'components/Modal';
import React from 'react';
import { useHistory } from 'react-router-dom';
import IntlHelper from 'utils/helpers/intl.helper';

const SaveModal = () => {
  const t = IntlHelper.useTranslator();
  const history = useHistory();

  const handleClose = () => {
    history.goBack();
  };

  return (
    <>
      <Modal.Header title={t('documento_salvato')} />
      <Modal.Footer
        confirmText={t('continua')}
        closeButtonText={t('chiudi')}
        cancelAction={handleClose}
      />
    </>
  );
};

export default SaveModal;
